/* global ga,StackTrace,console */

(function () {
  'use strict';

  /* Services */
  angular.module('wsLrs.services').
  /**
   * The "stacktrace" library that we included in the Scripts
   * is now in the Global scope; but, we don't want to reference
   * global objects inside the AngularJS components - that's
   * not how AngularJS rolls; as such, we want to wrap the
   * stacktrace feature in a proper AngularJS service that
   * formally exposes the print method.
   **/
  factory("StackTrace", function () {
    return {
      get: function get(options) {
        return StackTrace.get(options);
      },
      fromError: function fromError(err, options) {
        var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        if (isIE11) {
          err.message = "[IE 11 ERROR] " + err.message;
        }
        return StackTrace.fromError(err, options);
      }
    };
  }).
  /**
   * By default, AngularJS will catch errors and log them to
   * the Console. We want to keep that behavior; however, we
   * want to intercept it so that we can also log the errors
   * to the server for later analysis.
   **/
  provider("$exceptionHandler", {
    /**
     * The error log service is our wrapper around the core error
     * handling ability of AngularJS. Notice that we pass off to
     * the native "$log" method and then handle our additional
     * server-side logging.
     **/
    $get: ['$log', '$window', 'ServerLog', 'StackTrace', function ($log, $window, ServerLog, StackTrace) {
      function log(exception, cause) {
        /**
         * Pass off the error to the default error handler
         * on the AngularJS logger. This will output the
         * error to the console (and let the application
         * keep running normally for the user).
         **/

        var logArguments = arguments;
        function handleDefaultAngularBehavior() {
          $log.error.apply($log, logArguments);
        }
        try {
          StackTrace.fromError(exception, {
            offline: true
          }).then(function (stackFrames) {
            exception.stack = exception.toString() + "\n";
            _.forEach(stackFrames, function (stackFrame) {
              var source = stackFrame.source;
              if (!source) {
                source = "   " + stackFrame.functionName + " (" + stackFrame.fileName + ":" + stackFrame.lineNumber + ":" + stackFrame.columnNumber + ")";
              }
              exception.stack += source + "\n";
            });
            handleDefaultAngularBehavior(logArguments);
            return stackFrames;
          }).catch(_.partial(handleDefaultAngularBehavior, logArguments)).then(function (stackFrames) {
            // Don't log these unhandled rejection errors on the server
            if (exception && exception.toString().indexOf("Possibly unhandled rejection") === 0) {
              return;
            }

            // Log the JavaScript error to the server.
            ServerLog.send("error", undefined, exception, {
              cause: cause || "JavaScript",
              stackFrames: stackFrames
            });
            if (typeof ga !== 'undefined') {
              ga('send', 'exception', {
                'exDescription': exception.toString(),
                'exFatal': false
              });
            }
          });
        } catch (e) {
          console.log("Unhandled exception: ", exception);
        }
      }

      // Return the logging function.
      return log;
    }]
  }).factory("ServerLog", ['wsApiUrl', '$window', '$log', 'xsrf', function (wsApiUrl, $window, $log, xsrf) {
    return {
      send: _.debounce(function (level, message, exception, options) {
        if (typeof message !== "string") {
          message = JSON.stringify(message);
        }
        var data = options || {};
        angular.extend(data, {
          level: level,
          message: message,
          url: $window.location.href
        });
        if (exception) {
          data.name = exception.name;
          if (!data.message) {
            data.message = exception.toString();
          }
          data.cause = exception.cause;
        }
        try {
          $.ajax({
            type: "POST",
            url: wsApiUrl + "/log",
            contentType: "application/json",
            data: angular.toJson(data),
            beforeSend: function beforeSend(xhr) {
              if (!this.crossDomain) {
                xsrf.addHeadersToXhr(xhr);
              }
            }
          });
        } catch (loggingError) {
          // For Developers - log the log-failure.
          $log.warn("Error logging failed");
          $log.log(loggingError);
        }
      }, 1000)
    };
  }]).
  /**
   * Configurable logger that wraps AngularJS's $log service.
   * Can log at varying levels, going from
   * 'debug' -> 'info' -> 'warn' -> 'error'
   *
   * Specifying 'none' or any unrecognized value results
   * in no logging.
   **/
  factory('Logger', ['$log', 'Config', 'ServerLog', function ($log, Config, ServerLog) {
    /*jshint loopfunc: true */
    var logLevel = Config.get().logLevel;
    var logger = {
      trace: function trace() {},
      debug: function debug() {},
      info: function info() {},
      warn: function warn() {},
      error: function error() {}
    };
    if (logLevel !== 'none') {
      var levelMet = false;
      for (var key in logger) {
        if (logger.hasOwnProperty(key)) {
          if (key === logLevel) {
            levelMet = true;
          }
          if (levelMet) {
            logger[key] = function (key) {
              return function (x0) {
                if (key === "error") {
                  ServerLog.send(key, x0);
                }
                if (typeof $log[key] === 'function') {
                  for (var _len = arguments.length, xs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    xs[_key - 1] = arguments[_key];
                  }
                  $log[key].apply($log, [x0].concat(xs));
                }
              };
            }(key);
          }
        }
      }
    }
    return logger;
  }]);
})();
